<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">About Us</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool05/1.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Welcome to the School of Allied Health Sciences</h2>
                <p>The ARNI School of Allied Health Sciences provides a dynamic learning environment that merges
                    theoretical knowledge with practical skills and practice to train students for the healthcare
                    industry. The school is dedicated to shaping fully skilled healthcare professionals who embrace the
                    medical field with expertise, compassion, and technology. Allied science plays a pivotal role in
                    medical treatment, handling treatment, illness prevention, and diagnosing. With programs such as BSc
                    in allied health sciences, they are ready to contribute significantly to the healthcare sector for
                    the betterment of society.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision </b> – We envision training competent and knowledgeable healthcare professionals who
                    contribute
                    meaningfully to the well-being of society. We want to be the leading name in the allied health
                    science sector for producing eligible professionals.
                </p>
                <p><b>Mission </b> – Our mission is to provide a strong focus on ethical practice, hands-on experience,
                    and
                    critical thinking healthcare professionals who are not just proficient with their business but
                    emphatic towards their patients.
                </p>
                <h2>Master’s and Bachelor of Science in Allied Health Sciences</h2>
                <p>Our university takes pleasure in providing a wide variety of allied health science courses in six
                    vibrant departments, each specifically designed to address the changing demands of the healthcare
                    sector. We provide students with a comprehensive educational experience that combines academic
                    knowledge with real-world application, all while fostering the development of knowledgeable and
                    caring professionals. Our committed instructors and cutting-edge facilities guarantee that you
                    obtain the best education possible, regardless of your career goals—whether they are in medical
                    imaging, medical laboratory sciences, rehabilitation treatments, surgical aid, or vision care. Our
                    demanding curriculum is intended to provide you with the know-how and abilities you need to succeed
                    in your chosen sector and significantly improve the health and well-being of both individuals and
                    communities.
                </p>
                <p><b>Scope </b>: The health care management degree program offers a comprehensive education in various
                    disciplines, including Radiology, Medical Laboratory Technology, Bachelor of Physiotherapy,
                    Anesthesia Technology, Operation Theater Technology, and Optometry and Forensic Sciences.
                </p>
                <ul>
                    <li>These programs equip students with diverse skills for the healthcare industry, preparing them
                        for various roles such as diagnosis, treatment planning, patient rehabilitation, and surgical
                        equipment management.
                    </li>
                    <li>Vast Career Opportunities in hospitals, diagnostic labs, research institutions, rehabilitation
                        centers, and community health organizations.
                    </li>
                    <li> Active involvement in research projects addressing critical health issues and developing
                        innovative solutions.
                    </li>
                </ul>
                <p><b>Whether your goal is to serve people, explore vast career opportunities, or improve the healthcare
                    industry. Our course will work as the foundation of your dreams. Join us in shaping a healthier
                    tomorrow.
                </b></p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">7</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">16</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Radiology</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BSC (MRIT)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Operation Theatre Technology</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BSC (OTT)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Anesthesia</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BSC (Anesthesia)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Optometry</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BSC (Optometry)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Medical Lab Technology</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BMLT</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Physiotherapy</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BSC (Physiotherapy)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Naturopathy & Yogic Sciences</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BNYS</td>
                        </tr>
                        <tr>
                            <td class="time">2.5 Years</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</section>
